import { NotePencil } from "@phosphor-icons/react";

export default function ObservationsBox({ value, onChange, disabled = false }) {
  return (
    <section className="bg-white rounded-xl border border-[#E5E7EB] p-5" data-testid="observations-section">
      <h2 className="text-base font-black tracking-tighter text-[#0F1829] flex items-center gap-2 mb-3" style={{ fontFamily: "'Fraunces', sans-serif" }}>
        <NotePencil size={18} className="text-[#002480]" />
        Observações
      </h2>
      <textarea rows={3}
        value={value} onChange={(e) => onChange?.(e.target.value)}
        disabled={disabled}
        placeholder="Indique aqui qualquer nota que queira incluir na encomenda (opcional)."
        data-testid="observations-input"
        className="w-full px-3 py-2 border border-[#E5E7EB] rounded-md text-sm resize-none focus:outline-none focus:ring-2 focus:ring-[#0F1829]/30 focus:border-[#0F1829] transition-all" />
    </section>
  );
}
